import { InitPage } from "../index";

const CHANGE_STATUS_MODALS = ".newChangeStatus, .editChangeStatus";
const MULTI_SELECTS = "select[name='antennas[]'], select[name='skip_status[]'], select[name='exception_item_types[]'], select[name='exception_live_from_thief_status[]']";

class ChangeStatusForm {
  constructor() {
    $(document).on("shown.bs.modal", CHANGE_STATUS_MODALS, (e) => {
      const modal = $(e.currentTarget);

      modal.find(MULTI_SELECTS).each((_index, element) => {
        const select = $(element);

        select.select2({
          placeholder: select.data("placeholder"),
          allowClear: true,
          width: "80%",
          dropdownParent: modal
        });
      });
    });

    $(document).on("hidden.bs.modal", CHANGE_STATUS_MODALS, (e) => {
      $(e.currentTarget).find(MULTI_SELECTS).each((_index, element) => {
        const select = $(element);

        if (select.hasClass("select2-hidden-accessible")) {
          select.select2("destroy");
        }
      });
    });
  }
}

export function LoadPage(): void {
  InitPage("location_setting_zone_unauthorizeds", () => {
    new ChangeStatusForm();
  });
}
